import { useAdaptivityWithJSMediaQueries } from '@vkontakte/vkui';

export const useAdaptiveWidget = () => {
  const { viewWidth, isDesktop } = useAdaptivityWithJSMediaQueries();
  // small_mobile || mobile
  const isMobile = viewWidth === 1 || viewWidth === 2;

  // small_tablet || tablet
  const isTablet = viewWidth === 3 || viewWidth === 4;

  return {
    isMobile,
    isTablet,
    isDesktop,
  };
};
